/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { feedControllerFindAll } from '../fn/feed/feed-controller-find-all';
import { FeedControllerFindAll$Params } from '../fn/feed/feed-controller-find-all';
import { FeedDto } from '../models/feed-dto';

@Injectable({ providedIn: 'root' })
export class FeedService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `feedControllerFindAll()` */
  static readonly FeedControllerFindAllPath = '/api/feeds';

  /**
   * 모든 피드 링크 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `feedControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  feedControllerFindAll$Response(params?: FeedControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeedDto>>> {
    return feedControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 피드 링크 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `feedControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  feedControllerFindAll(params?: FeedControllerFindAll$Params, context?: HttpContext): Observable<Array<FeedDto>> {
    return this.feedControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FeedDto>>): Array<FeedDto> => r.body)
    );
  }

}
